/** Trigger the browser-owned PWA installation prompt captured by App.js. */
export async function requestPwaInstall(browserWindow = window) {
  const promptEvent = browserWindow.__lefteriaInstallPrompt;
  if (!promptEvent) return { shown: false, outcome: "unavailable" };

  try {
    // Call prompt synchronously from the click handler so browsers keep the
    // user-gesture requirement for showing their native install dialog.
    await promptEvent.prompt();
    const choice = await promptEvent.userChoice;
    return { shown: true, outcome: choice?.outcome || "unknown" };
  } catch {
    return { shown: false, outcome: "error" };
  } finally {
    if (browserWindow.__lefteriaInstallPrompt === promptEvent) {
      browserWindow.__lefteriaInstallPrompt = null;
    }
    browserWindow.dispatchEvent(new Event("lefteria-install-prompt-consumed"));
  }
}

